import { Modal } from "./Modal";

interface FeedbackModalProps {
  id?: string;
  isOpen: boolean;
  title: string;
  description?: string;
  descriptionClassName?: string;
  className?: string;
  icon?: string;
  blurColor?: string;
  buttonText?: string;
  autoClose?: boolean;
  closeButtonClassName?: string;
  onClose?: () => void;
}

export function FeedbackModal({
  id,
  isOpen,
  title,
  description,
  descriptionClassName,
  className,
  icon,
  autoClose = false,
  blurColor = "bg-[#D4FFDECC]",
  onClose,
  closeButtonClassName,
}: FeedbackModalProps) {
  if (!isOpen) return null;

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      imgSrc={icon}
      showImg={!!icon}
      imgBlurColor={blurColor}
      className={className}
      onClose={onClose}
      showClose={!!onClose}
      autoClose={autoClose}
      closeButtonClassName={closeButtonClassName}
    >
      <h2 className="mt-3 text-center text-lg font-semibold text-[#111111]">
        {title}
      </h2>
      {description && (
        <p
          className={`mt-2 text-center text-sm text-[#111111] ${descriptionClassName}`}
        >
          {description}
        </p>
      )}
    </Modal>
  );
}
